// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox__checkbox__Rik1q"};